export default "__VITE_ASSET__MqAxsIqw__"